import { render } from "./CreateEditPost.vue?vue&type=template&id=6b7c9cd0"
import script from "./CreateEditPost.vue?vue&type=script&lang=js"
export * from "./CreateEditPost.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__